export const LOCAL_IMAGES: Record<string, string> = {
  qimalabsLogo: 'assets/images/QIMAlabs-logo.svg',
  helpGuide: 'assets/images/user-guide/help-guide-temp.png',
  plank: 'assets/images/user-guide/plank.svg',
  filter: 'assets/icons/bi_filter.svg',
  operate: 'assets/icons/ic-response-yes-no.svg',
  changeDirection: 'assets/icons/change-table-view.svg',
  exitFullscreen: 'assets/icons/exit-full-screen.svg',
  pageNotFound: 'assets/images/error/page-not-found.svg',
  internalServerError: 'assets/images/error/internal-server-error.svg',
  time: 'assets/icons/time.svg',
  forbidden: 'assets/images/error/forbidden.svg',
  deActive: 'assets/icons/de-active.svg',
  lockClosed: 'assets/icons/lock-closed.svg',
  lockSelf: 'assets/icons/lock-self.svg',
  syncData: 'assets/icons/sync-data.svg',
  reTest: 'assets/icons/re-test.svg',
  erase: 'assets/icons/erase.svg',
  frame: 'assets/icons/frame.svg',
  reFilter: 'assets/icons/extra-filter.svg',
  scan: 'assets/images/scan.png',
  overViewEmpty: 'assets/images/over-view-empty.gif',
  errorFull: 'assets/icons/error-full.svg',
  successFull: 'assets/icons/success-full.svg',
  firstPage: 'assets/icons/first-page.svg',
  emptyImage: 'assets/images/empty-image.png',
  largeIcon: 'assets/icons/large.svg',
  largeHoleIcon: 'assets/icons/large-hole.svg',
  exportTemp: 'assets/icons/export-temp.svg',
  testSection: 'assets/icons/test-section.svg',
  resultTable: 'assets/icons/result-table.svg',
  additionalSummary: 'assets/icons/additional-summary.svg',
  reportAllocation: 'assets/icons/report-allocation.svg',
  emptyGif: 'assets/images/empty-gif.gif',
  recentChanges: 'assets/icons/recent-changes.svg',
  parameterAsRow: 'assets/icons/parameter-as-row.svg',
  testPointAsRow: 'assets/icons/test-point-as-row.svg',
  noResultTable: 'assets/icons/no-result-table.svg',
  testResult: 'assets/icons/test-result.svg',
  photoArea: 'assets/icons/photo-area.svg',
  hourglass: 'assets/icons/hourglass.svg',
  firstPageFull: 'assets/icons/first-page-full.svg',
  quantityFill: 'assets/icons/quantity-fill.svg',
  downloadWord: 'assets/icons/download-word.svg',
  downloadWordDisabled: 'assets/icons/download-word-disabled.svg',
  emailFill: 'assets/icons/email-fill.svg',
  folder: 'assets/icons/folder.svg',
  info: 'assets/icons/info.svg',
  batchAddFirstPage: 'assets/icons/batch-add.svg',
  noPermission: 'assets/icons/no-permission.svg',
  wordGenerating: 'assets/images/word-generating.gif',
  generatingGif: 'assets/images/generating.gif',
  generationFailedGif: 'assets/images/generation-failed.gif',
  previewGif: 'assets/images/preview.gif',
  transferBackground: 'assets/images/transfer-background.svg',
  uploadWord: 'assets/icons/upload-word.svg',
  uploadWordComplete: 'assets/icons/upload-word-complete.svg',
  firstPageFP: 'assets/icons/first-page-fp.svg',
  firstPageReport: 'assets/icons/first-page-report.svg',
  autoFill: 'assets/icons/auto-fill.svg',
  folderFill: 'assets/icons/folder-fill.svg',
  backToTop: 'assets/icons/back-to-top.svg',
  duplicateIcon: 'assets/icons/duplicate.svg',
};
